import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-zinc-900" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-190">
            🛒 ELEGÍ TU MASTERPACK
          </h2>
          <p className="text-zinc-200 text-[16px]" data-id="element-191">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-192">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-black/80 rounded-3xl p-8 shadow-2xl border border-amber-900/40 flex flex-col h-full" data-id="element-193">
            <div className="mb-6" data-id="element-194">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-195">
                🏆 MASTERPACK APUESTAS MUNDIAL
              </h3>
              <p className="text-amber-300 font-bold" data-id="element-196">6 Tomos + 4 Bonus</p>
            </div>

            <div className="mb-6 pb-6 border-b border-amber-900/30" data-id="element-197"></div>

            <div className="mb-8" data-id="element-198">
              <div className="flex items-end gap-2" data-id="element-199">
                <span className="text-5xl font-black text-white" data-id="element-200">$19.990</span>
                <span className="text-xl font-bold text-amber-300 mb-1" data-id="element-201">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-202">
              {['6 Tomos completos (Fundamentos → Mundial 2026)', '4 Bonus estratégicos', '400+ páginas de sistema completo', 'Checklist + Plantilla + Fixture + Glosario', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-203">
                  <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-204" />
                  <span className="text-zinc-100" data-id="element-205">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53544064155966:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-206">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-207">
                🔥 QUIERO MI MASTERPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black rounded-3xl p-8 shadow-2xl border-2 border-amber-400 flex flex-col h-full relative lg:scale-105 z-10" data-id="element-208">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-400 text-black px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-209">
              <Star className="w-4 h-4 fill-black" data-id="element-210" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-211">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-212">
                ⚡ MASTERPACK + ELITE BETTING SYSTEM
              </h3>
              <p className="text-amber-400 font-bold text-[14px]" data-id="element-213">
                6 Tomos + 4 Bonus + Sistema de Análisis Avanzado y Psicología
              </p>
              <p className="text-zinc-400 text-sm mt-1" data-id="element-214">
                (análisis estadístico, modelo de Poisson y tracker en Excel)
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-amber-900/30" data-id="element-215"></div>

            <div className="mb-8" data-id="element-216">
              <div className="flex items-end gap-2" data-id="element-217">
                <span className="text-5xl font-black text-white" data-id="element-218">$27.990</span>
                <span className="text-xl font-bold text-zinc-400 mb-1" data-id="element-219">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-220">
              <li className="flex items-start gap-3" data-id="element-221">
                <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-222" />
                <span className="text-white font-bold" data-id="element-223">
                  Todo lo del Masterpack Apuestas Mundial, MÁS:
                </span>
              </li>
              {['Tomo Elite 1 — Análisis estadístico avanzado (xG, Poisson, clustering)', 'Tomo Elite 2 — Psicología de alto rendimiento del apostador', 'Tomo Elite 3 — Guía de enfoques de investigación aplicados', 'Tracker Elite en Excel con dashboard automático y calculadora de value', 'Bonus Elite 1 — Guía de pensamiento probabilístico profundo (12 ejercicios)', 'Bonus Elite 2 — Plantilla con modelo de Poisson integrado', 'Bonus Elite 3 — Base de datos de tendencias del Mundial 1990-2022'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-224">
                  <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-225" />
                  <span className="text-zinc-300" data-id="element-226">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53544086602046:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-227">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-228">
                ⚡ QUIERO EL MASTERPACK + ELITE SYSTEM
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}